<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">
      Conferma registrazione
    </h1>
    <p class="text-muted-foreground text-sm">
      Inserisci il codice ricevuto via email
    </p>
  </div>
  <div class="grid gap-6">
    <form [formGroup]="form" (ngSubmit)="confirmSignUp()">
      <div class="space-y-2">
        <label hlmLabel> Codice di conferma </label>
        <brn-input-otp
          hlm
          [maxLength]="6"
          inputClass="disabled:cursor-not-allowed"
          formControlName="code"
          [transformPaste]="transformPaste"
          (completed)="confirmSignUp()"
          class="w-full flex justify-center"
        >
          <div hlmInputOtpGroup>
            <hlm-input-otp-slot [index]="0" />
            <hlm-input-otp-slot [index]="1" />
            <hlm-input-otp-slot [index]="2" />
            <hlm-input-otp-slot [index]="3" />
            <hlm-input-otp-slot [index]="4" />
            <hlm-input-otp-slot [index]="5" />
          </div>
        </brn-input-otp>
      </div>

      <button hlmBtn [disabled]="isLoading()" class="mt-2 w-full">
        @if (isLoading()) {
          <hlm-spinner size="sm" class="mr-2" />
        }
        Conferma
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="isLoading()"
        class="w-full"
        (click)="onResendCodeClick()"
        type="button"
      >
        Invia nuovamente il codice
      </button>

      <button
        hlmBtn
        variant="link"
        class="w-full"
        [disabled]="isLoading()"
        (click)="onSignInClick()"
        type="button"
      >
        Torna al login
      </button>
    </form>
  </div>
</div>
